import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LinearModuleContentDirective } from './components/module-container/directives/linear-module-content.directive';
import { LinearModuleHeaderDirective } from './components/module-container/directives/linear-module-header.directive';
import LinearModuleContainerComponent from './components/module-container/linear-module-container.component';
import LinearBetslipMessagesService from './linear-betslip-messages.service';

@NgModule({
    imports: [CommonModule],
    providers: [LinearBetslipMessagesService],
    declarations: [LinearModuleContainerComponent, LinearModuleHeaderDirective, LinearModuleContentDirective],
    exports: [LinearModuleContainerComponent, LinearModuleHeaderDirective, LinearModuleContentDirective],
})
export class LinearBetslipModule {}
